import { useMemo } from 'react';
import OpenConstructionCostInfo, {
  OpenConstructionCostSnapshot,
} from '@/components/Approval/@components/OpenConstructionCost';
import OpenConstructionCostSettlementInfo, {
  OpenConstructionCostSettlementSnapshot,
} from '@/components/Approval/@components/OpenConstructionCostSettlement';
import {
  isOpenConstructionCostSettlementType,
  parseOpenConstructionCostAttributes,
} from '@/utils/approval/openConstructionCost';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/**
 * 233 매장 OPEN·234 정산 — 결재된 내용이 바뀌지 않게 저장 HTML(content) 그대로(레거시 조회와 동일).
 * content 가 없을 때만 data 로 그림
 */
const OpenConstructionCostSlot = ({ data }: ContentExtraProps) => {
  const cost = useMemo(
    () => parseOpenConstructionCostAttributes(data.attributes),
    [data.attributes],
  );
  const content = (data.attributes as { content?: unknown } | null)?.content;
  if (!cost) return null;
  if (isOpenConstructionCostSettlementType(data.apvType)) {
    return (
      <ContentSlotRoot>
        {typeof content === 'string' && content.trim() ? (
          <OpenConstructionCostSettlementSnapshot
            content={content}
            data={cost.data}
          />
        ) : (
          <OpenConstructionCostSettlementInfo data={cost.data} />
        )}
      </ContentSlotRoot>
    );
  }
  return (
    <ContentSlotRoot>
      {typeof content === 'string' && content.trim() ? (
        <OpenConstructionCostSnapshot content={content} data={cost.data} />
      ) : (
        <OpenConstructionCostInfo data={cost.data} />
      )}
    </ContentSlotRoot>
  );
};

export default OpenConstructionCostSlot;
